import { Link } from 'react-router-dom';
import { articles } from '@/mocks/gossip';

const tickerItems = articles.slice(0, 8);

export default function NewsTicker() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto flex w-full max-w-6xl items-center gap-4 overflow-hidden px-4 py-3 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50">
          <i className="ri-flashlight-fill"></i>
          实时热榜
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex w-max items-center gap-10">
            {[...tickerItems, ...tickerItems].map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                to={`/gossip/${item.id}`}
                className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-700"
              >
                {item.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}